





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import Swatch from "@/components/designer/fabric/Swatch.vue";
import ValanceGroup from "@/components/designer/sidebar/canopy/ValanceGroup.vue";
import FabricSelector from "@/components/designer/fabric/picker/FabricSelector.vue";
import CanopyLayouts from "./CanopyLayouts";
import FlipValancePanels from "@/components/designer/sidebar/canopy/FlipValancePanels.vue";
import { Fringe, Valance } from "@/models/configurator/configurator_options";
import UIkit from "uikit";

@Component({
  components: {
    Swatch,
    ValanceGroup,
    FabricSelector,
    FlipValancePanels,
  },
})
export default class StandardLayout extends CanopyLayouts {
  mounted(): void {
    this.readStoreData();
    // Initialize accordions
    this.initAccordions();
    // Set initial state based on stock mode
    this.handleStockModeChange(this.isStockOnly);
  }

  protected initAccordions(): void {
    const accordions = this.$el.querySelectorAll("[uk-accordion]");
    accordions.forEach(accordion => {
      UIkit.accordion(accordion);
    });
  }

  @Watch("isStockOnly")
  protected onStockModeChange(newVal: boolean): void {
    this.handleStockModeChange(newVal);
  }

  protected handleStockModeChange(isStockOnly: boolean): void {
    // Get all accordion containers
    const mainAccordion = this.$el.querySelector(".main-accordion");
    const valanceAccordion = this.$el.querySelector(".valance-accordion");

    if (isStockOnly) {
      // Close vent section if exists (it's the 2nd section in main accordion)
      if (this.hasVent && mainAccordion) {
        const ventSection = mainAccordion.children[1];
        if (ventSection?.classList.contains("uk-open")) {
          UIkit.accordion(mainAccordion).toggle(1, false);
        }
      }

      // Close rib attachment section if exists (3rd section in main accordion)
      const ribSectionExists =
        this.ribAttachment.pockets.includes(this.collection.handle) ||
        this.ribAttachment.grommets.includes(this.collection.handle);
      if (ribSectionExists && mainAccordion) {
        const ribSection = mainAccordion.children[2];
        if (ribSection?.classList.contains("uk-open")) {
          UIkit.accordion(mainAccordion).toggle(2, false);
        }
      }

      // Close valance section if exists (1st section in valance accordion)
      if (this.hasValance && valanceAccordion) {
        const valanceSection = valanceAccordion.children[0];
        if (valanceSection?.classList.contains("uk-open")) {
          UIkit.accordion(valanceAccordion).toggle(0, false);
        }
      }
    }
  }

  // ToDo: FUMBSD-612_fringe: Toggle the main accordion. BEWARE OF DUPLICATE WATCHER IMPACTS FOR 'valance'.
  protected async onValanceChange(newVal: Valance): Promise<void> {
    await this.addValance(newVal);
    console.log("Valance updated:", newVal);
    console.log("stored valance on valance change:", this.valance);
    // If valance is set to canopy, close the fringe accordion
    if (newVal === Valance.Canopy) {
      const fringeSection = this.$el.querySelector(
        ".valance-accordion > *:nth-child(2)"
      );

      const valanceAccordion = this.$el.querySelector(".valance-accordion");
      if (
        valanceAccordion &&
        fringeSection &&
        fringeSection.classList.contains("uk-open")
      ) {
        // if the accordion is open, close it
        UIkit.accordion(valanceAccordion).toggle(1, false);
      }
    }
  }

  protected readStoreData(): void {
    this.selectedMainCanopy = this.mainCanopy;
    this.selectedVentMiddle = this.ventMiddle;
    this.selectedRib = this.rib;
  }

  protected readonly RibPocketImg = require("@/assets/images/pocket.jpg");
  protected readonly RibGrommetImg = require("@/assets/images/grommets-standard.jpg");
  protected activeFringe = null;

  @Watch("activeFringe") 
  protected selectFringe(): void {
    const fabricOne = {
      "_id": "60b006995119130a58a7b0f3",
      "name": "Steel Blue",
      "mfr_code": "R-169",
      "frankford_code": "CPA",
      "mfr": "Recasens",
      "mfr_handle": "recasens",
      "brand": "Recacril",
      "brand_handle": "recacril",
      "image": "3-CPA.jpg",
      "index": 0,
      "grade": "a",
      "fabric_type": "acrylic",
      "is_select": false,
      "color_group": [
          "Blue"
      ],
      "pattern_group": [
          "Solids"
      ],
      "fabric_scale": 1,
      "brand_collection": "",
      "brand_collection_handle": "",
      "__v": 1,
      "pantone": "7453C",
      "retired_names": [
          "Capri"
      ],
      "weight": "9",
      "updated_at": "2025-01-09T19:21:59.646Z",
      "comparisons": [
          "4675"
      ]
  }
    const fabricTwo ={
    "_id": "60b006995119130a58a7b0f3",
    "name": "Steel Blue",
    "mfr_code": "R-169",
    "frankford_code": "CPA",
    "mfr": "Recasens",
    "mfr_handle": "recasens",
    "brand": "Recacril",
    "brand_handle": "recacril",
    "image": "3-CPA.jpg",
    "index": 0,
    "grade": "a",
    "fabric_type": "acrylic",
    "is_select": false,
    "color_group": [
        "Blue"
    ],
    "pattern_group": [
        "Solids"
    ],
    "fabric_scale": 1,
    "brand_collection": "",
    "brand_collection_handle": "",
    "__v": 1,
    "pantone": "7453C",
    "retired_names": [
        "Capri"
    ],
    "weight": "9",
    "updated_at": "2025-01-09T19:21:59.646Z",
    "comparisons": [
        "4675"
    ]
}
    const fabricThree = {
    "_id": "60b006995119130a58a7b0f3",
    "name": "Steel Blue",
    "mfr_code": "R-169",
    "frankford_code": "CPA",
    "mfr": "Recasens",
    "mfr_handle": "recasens",
    "brand": "Recacril",
    "brand_handle": "recacril",
    "image": "3-CPA.jpg",
    "index": 0,
    "grade": "a",
    "fabric_type": "acrylic",
    "is_select": false,
    "color_group": [
        "Blue"
    ],
    "pattern_group": [
        "Solids"
    ],
    "fabric_scale": 1,
    "brand_collection": "",
    "brand_collection_handle": "",
    "__v": 1,
    "pantone": "7453C",
    "retired_names": [
        "Capri"
    ],
    "weight": "9",
    "updated_at": "2025-01-09T19:21:59.646Z",
    "comparisons": [
        "4675"
    ]
}
    this.$viewer.ChangeFringe(this.activeFringe, fabricOne.mfr_code);

    // if (this.activeFringe == 'brush') {
    // this.$viewer.ChangeFringe(this.activeFringe, fabricOne.mfr_code);
    // } else if (this.activeFringe == 'short') {
    //   this.$viewer.ChangeFringe(this.activeFringe, fabricOne.mfr_code, fabricTwo.mfr_code);
    // } else if (this.activeFringe == 'long') {
    //   this.$viewer.ChangeFringe(this.activeFringe, fabricOne.mfr_code, fabricTwo.mfr_code, fabricThree.mfr_code);
    // } else {
    //   this.$viewer.ChangeFringe(null);
    // }
  }
  


  
  protected toggleValanceModal(e?: Event): void {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    UIkit.modal(document.getElementById("valance-modal") as HTMLElement).show();
  }
}
